import { httpRequest } from '@/services/httpClient'

export type Position = {
  positionId: number
  tenantId?: number
  code: string
  name: string
  description?: string | null
  departmentId?: number | null
  workModel?: string | null
  jobDefinition?: string | null
  responsibilities?: string | null
  trainingRequirements?: string | null
  experienceLevel?: string | null
  certifications?: string | null
  level?: string | null
  workingHours?: string | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  updatedAt?: string | null
}

export type PositionsListResponse = {
  items: Position[]
  totalCount: number
  page: number
  pageSize: number
}

export type PositionsListParams = {
  tenantId?: number
  departmentId?: number | null
  search?: string
  isActive?: boolean | null
  includeDeleted?: boolean
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name' | 'workModel' | 'updatedAt'
  sortDir?: 'asc' | 'desc'
}

export type CreatePositionPayload = {
  tenantId?: number
  code: string
  name: string
  description?: string | null
  departmentId?: number | null
  workModel?: string | null
  jobDefinition?: string | null
  responsibilities?: string | null
  trainingRequirements?: string | null
  experienceLevel?: string | null
  certifications?: string | null
  level?: string | null
  workingHours?: string | null
  isActive?: boolean
}

export type UpdatePositionPayload = CreatePositionPayload & {
  id: number
}

export type CreateUpdateResponse = {
  success: boolean
  data?: {
    id: number
    code: string
    name: string
  }
  message?: string
}

export const positionsApi = {
  list: (params: PositionsListParams) =>
    httpRequest<PositionsListResponse>('/v1/positions', {
      method: 'GET',
      query: {
        tenantId: params.tenantId,
        departmentId: params.departmentId ?? undefined,
        search: params.search?.trim() ? params.search.trim() : undefined,
        isActive: params.isActive === null ? undefined : params.isActive,
        includeDeleted: params.includeDeleted,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) => httpRequest<Position>(`/v1/positions/${id}`, { method: 'GET' }),

  create: (payload: CreatePositionPayload) =>
    httpRequest<CreateUpdateResponse>('/v1/positions', {
      method: 'POST',
      body: payload,
    }),

  update: (payload: UpdatePositionPayload) =>
    httpRequest<CreateUpdateResponse>(`/v1/positions/${payload.id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<{ success: boolean; message?: string }>(`/v1/positions/${id}`, {
      method: 'DELETE',
    }),
}
